import React from 'react'
import styles from './DevMode.module.css'

class DevMode extends React.Component {
  handleChange = e => {
    const name = e.target.name
    const value = e.target.value

    switch(name) {
      case 'backgroundZoom':
        this.props.onBackgroundChange(this.props.state.center, value / 100 + 1)
      break

      case 'backgroundX':
        this.props.onBackgroundChange([value, this.props.state.center[1]], this.props.state.zoom)
      break

      case 'backgroundY':
        this.props.onBackgroundChange([this.props.state.center[0], value], this.props.state.zoom)
      break

      default:
        return
    }
  }

  render() {
    return (
      <div className={styles.base}>
        <div><input type="range" name="backgroundZoom" min="0" max="100" onChange={this.handleChange} /></div>
        <div><input type="range" name="backgroundX" min="-100" max="100" onChange={this.handleChange} /></div>
        <div><input type="range" name="backgroundY" min="-100" max="100" onChange={this.handleChange} /></div>
        <div><input type="range" name="maskWidth" min="-100" max="100" onChange={this.handleChange} /></div>
        <div><input type="range" name="maskHeight" min="-100" max="100" onChange={this.handleChange} /></div>
        <div><input type="range" name="maskX" min="-100" max="100" onChange={this.handleChange} /></div>
        <div><input type="range" name="maskY" min="-100" max="100" onChange={this.handleChange} /></div>
      </div>
    )
  }
}

export default DevMode
